import { useEffect, useState } from 'react';
import { api } from '../api';
import { RepairDetail } from '../data/Repair';
import { usePartner } from './usePartner';

export function useRepairDetail(name: string, mail?: string) {
    const [repairDetail, setRepairDetail] = useState<RepairDetail | null>(null);
    const { partner, partnerLineUid, isLoading: isPartnerLoading } = usePartner();
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        if (!isPartnerLoading) {
            setLoading(true);
            api.repairDetail({
                name,
                login: mail || partner?.email || '',
                line_uid: mail ? '' : (partnerLineUid || ''),
            }).then((resData) => {
                setLoading(false);
                setRepairDetail(resData);
            }).catch(() => {
                setLoading(false);
            });
        }
    }, [isPartnerLoading]);

    return {
        repairDetail,
        isLoading,
    };
}
